<template>
  <div class="topbarnav">
    
    <!-- <div class="navli">
      <el-dropdown class="testdrop">
        <span class="el-dropdown-link">
          TMIP产品体系<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="maindiv" @click="goto('/mes')">
            <span>MES 生产管理</span>
          </div>
          <div class="maindiv" @click="goto('/wms')">
            <span>WMS 智慧仓储</span>
          </div>
          <div class="maindiv" @click="goto('/mtr')">
            <span>MTR 物料溯源</span>
          </div>
          <div class="maindiv" @click="goto('/emv')">
            <span>EMV 生产可视化</span>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->
    <div class="navli"  @click="goto('/')">
      <span>首页</span>
    </div>
    <div class="navli">
      <span @click="goto('/service')">服务与支持</span>
    </div>
    <div class="navli">
      <span @click="goto('/aboutus')">关于我们</span>
    </div>

    <div style="position:relative;left:120px;">
      <span class="el-icon-service"></span>
      <span>400-152-3152</span>
    </div>
  </div>
</template>

<script>
import util from "../util";
export default util.useCommon({
  data() {
    return {
      menushow: false,
    };
  },
  watch: {
  },
  methods: {
    showmenu() {
      this.menushow = true;
    },
    hidemenu() {
      this.menushow = false;
    },
    showmenuInfo() {
      this.menushow = true;
    },
    hidemenuInfo() {
      this.menushow = false;
    },
    goto(add) {
      this.$router.push(add);
    },
  },
  mounted() {
  },
  activated() {
  }
});
</script>
<style>
.el-popper .popper__arrow{
  display: none!important;
}
</style>
<style scoped>
.el-dropdown-link{
  font: normal normal normal 20px/18px Microsoft YaHei;
  color: #DBE0EE;
}
.testdrop /deep/ .el-dropdown-menu{
  border-radius: 8px;
}
</style>
